const request = ({ url, body, method } = { url: '/', body: {}, method: 'get' }) =>
    window.fetch(url, {
      method: method.toUpperCase(),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': body && body.token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
    .then(resp => resp.json())

export const postDealGiftsCallback = ({ postId, dealId, dealGiftId, provider, token }) =>
  request({
    url: '/kkru/share/deal_gifts/callback',
    method: 'post',
    body: {
      _method: 'get',
      deal_id: dealId,
      deal_gift_id: dealGiftId,
      post_id: postId,
      provider
    }
  })

export const wallShareSignalVK = ({ dealId, dealGiftId }) =>
  request({
    url: '/kkru/share/deal_gifts/vk_wall_share',
    method: 'post',
    body: {
      deal_id: dealId,
      deal_gift_id: dealGiftId
    }
  })

export const loginVk = (sid, redirectUri) =>
  request({
    url: `/api-kkru/v2/sessions/vk?auth=true&redirect_uri=${redirectUri}`,
    method: 'post',
    body: { code: sid }
  })

export const loginFb = accessToken =>
  request({
    url: '/api-kkru/v2/sessions/fb?auth=true',
    method: 'post',
    body: { access_token: accessToken }
  })



// WEBPACK FOOTER //
// app/javascript/src/services/api.js